import { ClockCircleOutlined } from '@ant-design/icons'
import { Statistic } from 'antd'
import dayjs, { Dayjs } from 'dayjs'
import { toInteger } from 'lodash'

import { OrderStatus } from '../../enums/OrderStatus'

import { OrderCountdownProps } from './interface'

const Preffix = () => {
  return (
    <span
      style={{
        color: 'black',
        fontSize: '0.8em'
      }}
    >
      剩余:
    </span>
  )
}

export const OrderCountdown = ({
  record: { status, processLimited, createdTime, sellerConfirmTime }
}: OrderCountdownProps) => {
  let deadline: Dayjs | undefined = undefined
  if (status === OrderStatus.WAIT_SELLER_CONFIRM) {
    deadline = dayjs(createdTime).add(24, 'h')
  } else if (
    status === OrderStatus.WAIT_BUYER_CONFIRM ||
    status === OrderStatus.ADJUST_PRICE
  ) {
    deadline = dayjs(sellerConfirmTime).add(
      processLimited ? toInteger(processLimited) : 24,
      'h'
    )
  }
  return deadline ? (
    <Statistic.Timer
      prefix={<Preffix />}
      suffix={<ClockCircleOutlined />}
      type='countdown'
      value={deadline.valueOf()}
      styles={{
        content: {
          fontSize: '1em',
          color: 'orange'
        }
      }}
    />
  ) : null
}
